<template>
  <div>
    <fidelior-title text="Citation Report" />
    <div class="alert alert-light border" role="alert">
      The <em>Citation Report</em> tool automates the current manual process of checking references. The tool provides indication of both reputable and pseudo-scientific journals in submitted manuscripts. Fidelior will generate more accurate results if only reference lists or bibliographies are uploaded.
    </div>
  </div>
</template>

<script>
export default {};
</script>